import { useTranslation } from 'react-i18next';

import { Collapse } from '@work4all/components/lib/components/collapse';
import { CheckboxRadioItem } from '@work4all/components/lib/input/checkbox-radio-item';

import {
  AppParts,
  useCanView,
  useHiddenEntities,
  useUser,
} from '@work4all/data';
import { useSetting } from '@work4all/data/lib/settings/use-setting';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import {
  canApproveVacations,
  canViewInboundInvoicesApprovalCenter,
  canViewTravelExpenses,
} from '@work4all/utils/lib/permissions';

import { settings } from '../../../../../../../settings';
import { DEFAULT_RELEVANT_WIDGET_VIEW } from '../../../../../../../settings/settings';

export function Personal() {
  const { t } = useTranslation();
  const { isHidden } = useHiddenEntities();
  const user = useUser();

  const canViewProjectTimeTracking = useCanView(AppParts.PROJECTTIMETRACKING);
  const canViewWorkTimeTracking = useCanView(AppParts.WORKTIMETRACKING);
  const canViewReApprovalCenter =
    useCanView(AppParts.INCOMING_INVOICE_LEDGER) &&
    canViewInboundInvoicesApprovalCenter(user);
  const canViewVacationApprovalCenter =
    useCanView(AppParts.VACATIONS) && canApproveVacations(user);
  const canViewApprovalCenter =
    canViewReApprovalCenter || canViewVacationApprovalCenter;
  const canViewTravelExpensesCalculated = canViewTravelExpenses(user);
  const relevantWidgetView = useSetting(settings.relevantWidgetVisibleViews());

  const handleCheck = (view: Entities, setVisible: boolean) => {
    if (setVisible) {
      relevantWidgetView.set([view, ...relevantWidgetView.value]);
    } else {
      relevantWidgetView.set(
        relevantWidgetView.value.filter((setting) => setting !== view)
      );
    }
  };

  const isSettingVisible = (setting: Entities) => {
    return relevantWidgetView.value.includes(setting);
  };

  const userEnabledShowingBirthdays = useSetting(
    settings.userEnabledShowingBirthdays()
  );

  const adminEnabledShowingBirthdays = useSetting(
    settings.adminEnabledShowingBirthdays()
  );

  const showingPermits = useSetting(settings.showingPermits());

  return (
    <Collapse title={t('RELEVENT.SETTINGS.SHOW')} defaultOpen>
      {DEFAULT_RELEVANT_WIDGET_VIEW.filter((el) => {
        if (el === Entities.vacation) return canViewWorkTimeTracking;
        if (el === Entities.timeTracking) return canViewProjectTimeTracking;
        if (el === Entities.travelExpenses)
          return canViewTravelExpensesCalculated;
        return !isHidden(el);
      }).map((entity) => {
        return (
          <CheckboxRadioItem
            key={entity}
            checked={isSettingVisible(entity)}
            onChange={(e) => {
              handleCheck(entity, e.target.checked);
            }}
            label={t(`COMMON.${entity.toUpperCase()}`)}
          />
        );
      })}

      {canViewApprovalCenter && (
        <CheckboxRadioItem
          checked={showingPermits.value}
          label={t('APPROVAL_CENTER.TITLE')}
          onChange={(e) => {
            showingPermits.set(e.target.checked);
          }}
        />
      )}

      {adminEnabledShowingBirthdays.value && (
        <CheckboxRadioItem
          checked={userEnabledShowingBirthdays.value}
          label={t('COMMON.BIRTHDAY_other')}
          onChange={(e) => {
            userEnabledShowingBirthdays.set(e.target.checked);
          }}
        />
      )}
    </Collapse>
  );
}
